<script>

debugHome24Clean = (enable = true) => {
  if (enable) {
    sessionStorage.debugHome24ShowClean = enable
  } else {
    sessionStorage.removeItem('debugHome24ShowClean')
  }
}

export default {
  components: {},
  methods: {},
  // mounted() { console.warn('mounted', this) },
  props: ["component", "handler"],
  data: function () {
    return {
      debugHome24ShowClean: sessionStorage.debugHome24ShowClean,
    };
  },
  computed: {
    progress: function () {
      return (
        (this.component.medias_directory_size * 100) /
        this.component.medias_directory_limit
      );
    },
  },
};
</script>

<template>
  <div class="home24-storage home24-box">
    <f-icon icon="fa6-database"></f-icon>
    <div class="home24-storage-infos">
      <div class="title">{{ $vt("Media Storage") }}</div>
      <div class="values">
        <div class="size" v-html="component.medias_directory_size > 0
          ? $options.filters.angularFilter(
            component.medias_directory_size,
            'bytesHtml'
          )
          : '0 GB'
          "></div>
        <div class="limit" v-html="$options.filters.angularFilter(
          component.medias_directory_limit,
          'bytesHtml'
        )
          "></div>
      </div>
      <div class="jauge">
        <div class="fill" :class="{ warning: progress > 75, danger: progress > 99 }" style="max-width: 100%;"
          :style="{ width: progress + '%' }">
        </div>
      </div>
    </div>
    <VuePlaceholder v-if="progress >= 75 || debugHome24ShowClean" :component="component.storage_clean"
      :handler="handler" />
  </div>
</template>

<style lang="scss">
.home24-storage {
  display: flex;
  gap: 16px;

  >.f-icon {
    font-size: 40px;
    color: var(--primary);
  }

  .home24-storage-infos {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;

    >.title {
      color: var(--white-a75);
      font-family: Lato;
      font-size: 16px;
      font-weight: 700;
      line-height: 19.2px;
      letter-spacing: 0.02em;
      text-align: left;
      text-transform: uppercase;
    }

    >.values {
      display: flex;
      color: var(--white-a75);
      font-family: Lato;
      font-size: 12px;
      font-weight: 400;
      line-height: 15px;
      text-align: left;

      >.limit {
        margin-left: auto;
      }
    }

    >.jauge {
      margin-top: 4px;
      width: 100%;
      position: relative;
      height: 8px;
      background-color: var(--navigation-a10);
      border-radius: 4px;

      >.fill {
        border-radius: 4px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: var(--primary);

        &.warning {
          background-color: var(--notice);
        }

        &.danger {
          background-color: var(--negative);
        }
      }
    }
  }
}
</style>